import { Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import { ValidateResult } from 'react-hook-form';
import { FormError } from 'shared/components/FormControl';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import { useFormSecurely } from 'lib/security/reactHookForm';

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-column-gap: ${Spacing[2]};
  align-items: start;
`;

interface FormNewGridLayoutTabProps {
  submit: (data: { tabName: string }) => void;
  validateTabName?: (tabName: string, tabToken?: string) => ValidateResult;
}

const FormNewGridLayoutTab: VFC<FormNewGridLayoutTabProps> = ({ submit, validateTabName }) => {
  const {
    register: wrappedRegister,
    handleSubmit,
    reset,
    formState: { isValid, errors },
  } = useFormSecurely<{ tabName: string }>({ mode: 'onChange' });

  // Unlike many of our other forms, this form is not unmounted after the
  // user submits the form, and so we have to manually reset the input on
  // submit.
  const submitAndClear: FormNewGridLayoutTabProps['submit'] = (data) => {
    submit(data);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(submitAndClear)}>
      <Container>
        <Input
          {...wrappedRegister('tabName', {
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            validate: (tabName) => validateTabName(tabName),
            required: true,
          })}
          id='name'
          type='text'
          title='Tab Name'
          placeholder='e.g. Summary'
        />
        <Button type='submit' data-test='form-new-case-layout-tab__submit' disabled={!isValid}>
          Add
        </Button>
        {errors.tabName && <FormError role='alert'>{errors.tabName.message}</FormError>}
      </Container>
    </form>
  );
};

export default FormNewGridLayoutTab;
